import imgcolor from './imgcolor/store';
import chartcolor from './chartcolor/store';

export default {
  namespaced: true,
  modules: { imgcolor, chartcolor },
};
